import type { FaireProductEntity } from "../../entity_types/product";

export const p_sjku8sxd8d: FaireProductEntity = {
  token: "p_sjku8sxd8d",
  type: "product",
  name: "Unisex Tye Dye Bob Ross Mid Crew Length Socks",
  brandToken: "b_5xdelgfsdc",
  brandName: "Gypsy Rose",
  imageUrl:
    "https://cdn.faire.com/fastly/172389d39b3a899b11fa37fb271745e9b5bf88e2ed4c8a2df19999af3bfab2d4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/75736f9413c68bbd453f579e2352bfa91ae9415c154f2167956bc7e1f2e1f112.png",
  ],
  priceDollars: 7,
  description:
    "Style: Crew length athletic sock.\n\n𝐒𝐢𝐳𝐞:\n• Small/Medium fits U.S. shoe men's 6 - 9 / women’s 5 - 8\n• Medium/Large fits U.S. shoe men's 9 - 12 / women’s 8 - 11\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥:\n• 65% Combed Cotton\n• 32% Nylon\n• 3% Spandex\n\nCare: Machine wash cold with no bleach and hang to dry",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:26.663Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
